<template>
    <b-modal v-model="modalShow" ref="modal-transf-client" size="lg" title="Transferir Cliente">
        <b-form novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.cpf_cnpj != '', 'has-danger' : validation.client.cpf_cnpj != ''}">
                        <label for="cpf_cnpj" class="bmd-label-floating">CPF/CNPJ <span class="text-danger">*</span></label>
                        <the-mask refs="cpf_cnpj" type="text" class="form-control" v-model="form.client.cpf_cnpj" v-on:blur.native="searchCpfCnpj" :mask="['###.###.###-##', '##.###.###/####-##']"></the-mask>
                        <label v-if="validation.client.cpf_cnpj != ''" id="cpf_cnpj-error" class="error" for="cpf_cnpj">{{ validation.client.cpf_cnpj }}</label>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.name != '', 'has-danger' : validation.client.name != ''}">
                        <label for="name" class="bmd-label-floating">Nome <span class="text-danger">*</span></label>
                        <input refs="name" type="text" class="form-control" v-model="form.client.name" />
                        <label v-if="validation.client.name != ''" id="name-error" class="error" for="name">{{ validation.client.name }}</label>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <h5 v-if="form.client.cpf_cnpj.length <= 11" class="info-text">
                RG
            </h5>
            <h5 v-else class="info-text">
                Insc. Estadual
            </h5>
            <hr />
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.registration_number != '', 'has-danger' : validation.client.registration_number != ''}">
                        <label for="registration_number" class="bmd-label-floating">Número <span class="text-danger">*</span></label>
                        <input refs="registration_number" v-numeric-only type="text" class="form-control" v-model="form.client.registration_number" />
                        <label v-if="validation.client.registration_number != ''" id="registration_number-error" class="error" for="registration_number">{{ validation.client.registration_number }}</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.dispatcher_registration_number != '', 'has-danger' : validation.client.dispatcher_registration_number != ''}">
                        <label for="dispatcher_registration_number" class="bmd-label-floating">Orgão Emissor <span class="text-danger">*</span></label>
                        <input refs="dispatcher_registration_number" type="text" class="form-control" v-model="form.client.dispatcher_registration_number" />
                        <label v-if="validation.client.dispatcher_registration_number != ''" id="dispatcher_registration_number-error" class="error" for="dispatcher_registration_number">{{ validation.client.dispatcher_registration_number }}</label>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.client.shipment_date_registration_number != ''}">
                        <label for="shipment_date_registration_number" class="bmd-label-floating">Expedição <span class="text-danger">*</span></label>
                        <date-picker v-model="form.client.shipment_date_registration_number" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" :not-after="new Date()"></date-picker>
                    </div>
                </div>
            </div>
            <div v-if="form.client.cpf_cnpj.length <= 11" class="row">
                <div class="col-md-3">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.nationality != ''}">
                        <label for="nationality" class="bmd-label-floating">Nacionalidade</label>
                        <input refs="nationality" type="text" class="form-control" v-model="form.client.nationality" />
                        <label v-if="validation.client.nationality != ''" id="nationality-error" class="error" for="nationality">{{ validation.client.nationality }}</label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.profession != ''}">
                        <label for="profession" class="bmd-label-floating">Profissão</label>
                        <input refs="profession" type="text" class="form-control" v-model="form.client.profession" />
                        <label v-if="validation.client.profession != ''" id="profession-error" class="error" for="profession">{{ validation.client.profession }}</label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group bmd-form-group is-filled">
                        <label for="profession" class="bmd-label-floating">Estado Civil</label>
                        <model-select :options="marital_status"
                            v-model="form.client.marital_status">
                        </model-select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group bmd-form-group is-filled">
                        <label for="profession" class="bmd-label-floating">Sexo</label>
                        <model-select :options="sexes"
                            v-model="form.client.sex">
                        </model-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.client.date_of_birth != ''}">
                        <label v-if="form.client.cpf_cnpj.length <= 11" for="date_of_birth" class="bmd-label-floating">Nascimento</label>
                        <label v-else for="date_of_birth" class="bmd-label-floating">Abertura</label>
                        <date-picker v-model="form.client.date_of_birth" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" :not-after="new Date()"></date-picker>
                        <label v-if="validation.client.date_of_birth != ''" id="date_of_birth-error" class="error" for="date_of_birth">{{ validation.client.date_of_birth }}</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-check bmd-form-group is-filled">
                        <label class="bmd-label-floating">Autoriza divulgar dados?</label>
                        <b-form-checkbox
                            id="checkbox1"
                            v-model="form.client.authorize_disseminate_data"
                            :value="true"
                            :unchecked-value="false">
                            {{ form.client.authorize_disseminate_data ? 'Sim': 'Não' }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <h5 class="info-text">
                Dados de Contato
            </h5>
            <hr />
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.mail != ''}">
                        <label for="mail" class="bmd-label-floating">E-mail <span class="text-danger">*</span></label>
                        <input refs="mail" type="mail" class="form-control" v-model="form.client.mail" />
                        <label v-if="validation.client.mail != ''" id="mail-error" class="error" for="mail">{{ validation.client.mail }}</label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.cell_phone != ''}">
                        <label for="cell_phone" class="bmd-label-floating">Telefone Celular <span class="text-danger">*</span></label>
                        <the-mask refs="cell_phone" type="text" class="form-control" v-model="form.client.cell_phone" :mask="['(##) #####-####']"></the-mask>
                        <label v-if="validation.client.cell_phone != ''" id="cell_phone-error" class="error" for="cell_phone">{{ validation.client.cell_phone }}</label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.home_phone != ''}">
                        <label for="home_phone" class="bmd-label-floating">Telefone Residencial</label>
                        <the-mask refs="home_phone" type="text" class="form-control" v-model="form.client.home_phone" :mask="['(##) ####-####']"></the-mask>
                        <label v-if="validation.client.home_phone != ''" id="home_phone-error" class="error" for="home_phone">{{ validation.client.home_phone }}</label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.commercial_phone != ''}">
                        <label for="commercial_phone" class="bmd-label-floating">Telefone Comercial</label>
                        <the-mask refs="commercial_phone" type="text" class="form-control" v-model="form.client.commercial_phone" :mask="['(##) ####-####']"></the-mask>
                        <label v-if="validation.client.commercial_phone != ''" id="commercial_phone-error" class="error" for="commercial_phone">{{ validation.client.commercial_phone }}</label>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <h5 class="info-text">
                Dados Bancários
            </h5>
            <hr />
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                        <label for="bank_id" class="bmd-label-floating">Banco</label>
                        <model-list-select 
                            class="form-control"
                            :list="banks"     
                            option-value="id"
                            option-text="name"
                            v-model="form.client.bank_id"
                            placeholder="Escolha um banco">
                        </model-list-select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-9">
                            <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.bank_branch != '' || form.client.bank_digit_branch != ''}">
                                <label for="bank_branch" class="bmd-label-floating">Agência</label>
                                <input refs="bank_branch" type="text" v-numeric-only class="form-control" v-model="form.client.bank_branch"></input>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group bmd-form-group">
                                <input refs="bank_digit_branch" maxlength="5" type="text" class="form-control" v-model="form.client.bank_digit_branch"></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-9">
                            <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.account_number != '' || form.client.account_digit != ''}">
                                <label for="account_number" class="bmd-label-floating">Número da conta</label>
                                <input refs="account_number" type="text" v-numeric-only class="form-control" v-model="form.client.account_number"></input>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group bmd-form-group">
                                <input refs="account_digit" maxlength="5" type="text" class="form-control" v-model="form.client.account_digit"></input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <h5 class="info-text">
                Endereço
            </h5>
            <hr />
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.cep != ''}">
                        <label for="cep" class="bmd-label-floating">CEP <span class="text-danger">*</span></label>
                        <the-mask refs="cep" type="text" class="form-control" v-model="form.address.cep" v-on:blur.native="searchCep" :mask="'##.###-###'" />
                        <label v-if="validation.address.cep != ''" id="address-error" class="error" for="address">{{ validation.address.cep }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.address != ''}">
                        <label for="address" class="bmd-label-floating">Endereço <span class="text-danger">*</span></label>
                        <input refs="address" type="text" class="form-control" v-model="form.address.address" />
                        <label v-if="validation.address.address != ''" id="address-error" class="error" for="address">{{ validation.address.address }}</label>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.number != ''}">
                        <label for="number" class="bmd-label-floating">Número</label>
                        <input refs="number" type="text" maxlength="15" class="form-control" v-model="form.address.number" />
                        <label v-if="validation.address.number != ''" id="number-error" class="error" for="number">{{ validation.address.number }}</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.borough != '', 'has-danger' : validation.address.borough != ''}">
                        <label for="borough" class="bmd-label-floating">Bairro <span class="text-danger">*</span></label>
                        <input refs="borough" type="text" class="form-control" v-model="form.address.borough" />
                        <label v-if="validation.address.borough != ''" id="borough-error" class="error" for="borough">{{ validation.address.borough }}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.complement != ''}">
                        <label for="complement" class="bmd-label-floating">Complemento</label>
                        <input refs="complement" type="text" class="form-control" v-model="form.address.complement" />
                        <label v-if="validation.address.complement != ''" id="complement-error" class="error" for="complement">{{ validation.address.complement }}</label>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger': validation.address.city.state.id != ''}">
                        <label for="state" class="bmd-label-floating">Estado <span class="text-danger">*</span></label>
                        <model-list-select 
                            class="form-control"
                            :list="states"     
                            option-value="id"
                            option-text="name"
                            v-model="form.address.city.state.id"
                            @input="onSelectState">
                        </model-list-select>
                        <label v-if="validation.address.city.state.id != ''" id="complement-error" class="error" for="complement">{{ validation.address.city.state.id }}</label>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger': validation.address.city.id != ''}">
                        <label for="city" class="bmd-label-floating">Cidade <span class="text-danger">*</span></label>
                        <model-list-select 
                            class="form-control"
                            :list="cities"     
                            option-value="id"
                            option-text="name"
                            v-model="form.address.city.id">
                        </model-list-select>
                        <label v-if="validation.address.city.id != ''" id="complement-error" class="error" for="complement">{{ validation.address.city.id }}</label>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitTransfClient" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>
<script>
    import ClientService from '@/services/modules/clients.service';
    import DefaultService from '@/services/modules/defaults.service';
    import ValidationService from '@/services/validations.service';

    export default {
        computed: {
            banks: {
                set(_banks) {

                },
                get() {
                    return this.$store.state.defaults.banks;
                }
            },
            states: {
                set(_states) {

                },
                get() {
                    return this.$store.state.defaults.states;
                }
            },
        },
        data() {
            return {
                cities: [],
                form: {
                    id: 0,
                    address: {
                        address: '',
                        cep: '',
                        number: '',
                        complement: '',
                        borough: '',
                        city: {
                            id: '',
                            state: {
                                id: ''
                            }
                        }
                    },
                    client: {
                        cpf_cnpj: '',
                        name: '',
                        registration_number: '',
                        dispatcher_registration_number: '',
                        shipment_date_registration_number: '',
                        nationality: '',
                        marital_status: '',
                        profession: '',
                        sex: '',
                        date_of_birth: '',
                        authorize_disseminate_data: false,
                        mail: '',
                        cell_phone: '',
                        home_phone: '',
                        commercial_phone: '',
                        bank_digit_branch: '',
                        bank_branch: '',
                        account_number: '',
                        account_digit: ''
                    },
                },
                marital_status: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: 'S', text: 'Solteiro'},
                    {value: 'C', text: 'Casado'},
                    {value: 'D', text: 'Divorciado'},
                    {value: 'V', text: 'Viúvo'},
                    {value: 'U', text: 'União Estável'},
                    {value: 'O', text: 'Outros'}
                ],
                modalShow: true,
                sexes: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: 'F', text: 'Feminino'},
                    {value: 'M', text: 'Masculino'},
                ],
                validation: {
                    address: {
                        address: '',
                        cep: '',
                        number: '',
                        complement: '',
                        borough: '',
                        city: {
                            id: '',
                            state: {
                                id: ''
                            }
                        }
                    },
                    client: {
                        cpf_cnpj: '',
                        name: '',
                        registration_number: '',
                        dispatcher_registration_number: '',
                        shipment_date_registration_number: '',
                        nationality: '',
                        marital_status: '',
                        profession: '',
                        sex: '',
                        date_of_birth: '',
                        authorize_disseminate_data: '',
                        mail: '',
                        cell_phone: '',
                        home_phone: '',
                        commercial_phone: '',
                    }
                }
            };
        },
        mounted() {
            var self = this;

            self.form.id = self.$route.params.id;

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });

            self.getDataStates();
        },
        methods: {
            goBack() {
                var self = this;
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            searchCep(_ev) {
                _ev.preventDefault();

                var self = this;
                var address = self.form.address;

                var cep = address.cep.replace(/[^\d]/g, '');

                if (cep.length < 8) {
                    return false;
                }

                self.$root.$emit("onLoading");

                const response = DefaultService.searchCep(cep);

                response.then(function (_response) {
                    self.$root.$emit("onLoading");

                    if (_response.resultado > 0) {
                        var states = self.states;

                        var index = (self.states.findIndex(states => states.id == _response.state_id) + 1);

                        self.onSelectState(index);

                        self.form.address.city.state.id = _response.state_id;

                        self.form.address.city.id = _response.city_id;

                        self.form.address.borough = _response.bairro;

                        self.form.address.address = _response.tipo_logradouro + " " + _response.logradouro;
                    } else {
                        self.$notify.error("Cep não localizado!");
                    }
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            searchCpfCnpj(_ev) {
                _ev.preventDefault();

                var self = this;

                var client = self.form.client;

                var cpfCnpj = client.cpf_cnpj.replace(/[^\d]/g, '');

                if (cpfCnpj.length < 11) {
                    return false;
                }
                const clients = ClientService.get({
                    cpf_cnpj: cpfCnpj
                });

                self.$root.$emit("onLoading");

                clients.then(function (_client) {
                    self.$root.$emit("onLoading");

                    if (_client.length > 0) {
                        self.form.client = _client[0];

                        var addresses = self.form.client.addresses;

                        if (addresses.length > 0) {
                            var index = (self.states.findIndex(states => states.id == addresses[0].city.state_id) + 1);

                            self.onSelectState(index);

                            self.form.address = addresses[0];
                        }
                    }
                });

                clients.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            onSelectState(_index) {
                this.cities = this.states[_index - 1].cities;
            },
            onSubmitTransfClient(_ev) {
                _ev.preventDefault();
                var self = this;

                if (!self.validateClient()) {
                    return false;
                }

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('proposals/edit', self.form);

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.success("Proposta transferida com sucesso!");
                    self.goBack();
                });

                response.catch(function (err) {
                    self.$root.$emit("onLoading");
                    if (err.status === 406 || err.status === 422) {
                        if (err.data.invoice_at !== undefined) {
                            self.validation.invoice_at = err.data.invoice_at[0];
                        }
                        if (err.data.observations !== undefined) {
                            self.validation.observations = err.data.observations[0];
                        }
                    }
                });
            },
            validateAddress() {
                var self = this;
                var form = self.form.address;
                var validation = self.validation.address;
                var valid = true;

                validation.cep = "";
                validation.address = "";

                if (form.cep === "") {
                    validation.cep = "Campo obrigatório!";
                    valid = false;
                }

                if (form.address === "") {
                    validation.address = "Campo obrigatório!";
                    valid = false;
                }

                if (form.borough === "") {
                    validation.borough = "Campo obrigatório!";
                    valid = false;
                }

                if (form.city.state.id === "") {
                    validation.city.state.id = "Campo obrigatório!";
                    valid = false;
                }

                if (form.city.id === "") {
                    validation.city.id = "Campo obrigatório!";
                    valid = false;
                }

                return valid;
            },
            validateClient() {
                var self = this;
                var form = self.form.client;
                var validation = self.validation.client;
                var valid = true;

                validation.cpf_cnpj = "";
                validation.name = "";
                validation.mail = "";
                validation.registration_number = "";
                validation.cell_phone = "";
                validation.home_phone = "";
                validation.commercial_phone = "";
                validation.dispatcher_registration_number = "";
                validation.shipment_date_registration_number = "";

                if (form.cpf_cnpj === "") {
                    validation.cpf_cnpj = "Campo obrigatório!";
                    valid = false;
                } else {
                    if (form.cpf_cnpj.length === 11) {
                        if (!ValidationService.cpf(form.cpf_cnpj)) {
                            validation.cpf_cnpj = "CPF inválido!";
                            valid = false;
                        }
                    } else if (form.cpf_cnpj.length === 14) {
                        if (!ValidationService.cnpj(form.cpf_cnpj)) {
                            validation.cpf_cnpj = "CNPJ inválido!";
                            valid = false;
                        }
                    } else {
                        validation.cpf_cnpj = "Campo inválido!";
                        valid = false;
                    }
                }
                
                if (form.dispatcher_registration_number === "") {
                    validation.dispatcher_registration_number = "Campo obrigatório!";
                    valid = false;
                }

                if (form.shipment_date_registration_number === "") {
                    validation.shipment_date_registration_number = "Campo obrigatório!";
                    valid = false;
                }

                if (form.name === "") {
                    validation.name = "Campo obrigatório!";
                    valid = false;
                }

                if (form.registration_number === "") {
                    validation.registration_number = "Campo obrigatório!";
                    valid = false;
                }

                if (form.mail == null || form.mail.length <= 1) {
                    validation.mail = "Campo obrigatório!";
                } else if (!ValidationService.mail(form.mail)) {
                    validation.mail = "E-mail inválido!";
                    valid = false;
                }
                
                if (form.cell_phone == null || form.cell_phone.length <= 1) {
                    validation.cell_phone = "Campo obrigatório!";
                    valid = false;
                }else if (!ValidationService.phone(form.cell_phone)) {
                    validation.cell_phone = "Telefone celular inválido!";
                    valid = false;
                }

                if (form.home_phone !== null && form.home_phone.length > 0 && !ValidationService.phone(form.home_phone)) {
                    validation.home_phone = "Telefone residencial inválido!";
                    valid = false;
                }

                if (form.commercial_phone !== null && form.commercial_phone.length > 0 && !ValidationService.phone(form.commercial_phone)) {
                    validation.commercial_phone = "Telefone comercial inválido!";
                    valid = false;
                }

                if (!self.validateAddress()) {
                    valid = false;
                }

                return valid;
            },
            async getDataBanks() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('defaults/banks');

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getDataStates() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('defaults/states');

                response.then(function () {
                    if (self.$store.state.defaults.banks.length === 0) {
                        self.getDataBanks();
                    }
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    if (self.$store.state.defaults.banks.length === 0) {
                        self.getDataBanks();
                    }
                    self.$root.$emit("onLoading");
                });
            }
        }
    };
</script>